import { ASSISTANT_PENDING_TEXT } from '@/constants/chat'

/** @param {Record<string, unknown>} prev @param {Record<string, unknown>} patch */
export function patchSyntheticDataDemoMessage(prev, patch) {
  return { ...prev, ...patch }
}

/** @param {Function} setMessagesByThreadId @param {string} tid @param {string} pendingId @param {Record<string, unknown>} patch */
export function updatePendingSyntheticDataDemoMessage(setMessagesByThreadId, tid, pendingId, patch) {
  setMessagesByThreadId((inner) => {
    const list = [...(inner[tid] ?? [])]
    const idx = list.findIndex((m) => m.id === pendingId)
    if (idx === -1) return inner
    const next = [...list]
    next[idx] = patchSyntheticDataDemoMessage(list[idx], patch)
    return { ...inner, [tid]: next }
  })
}

export function initialSyntheticDataStreamPatch(prev) {
  return patchSyntheticDataDemoMessage(prev, {
    text: ASSISTANT_PENDING_TEXT,
    demoStreamActive: true,
    thoughtSummary: 'Thinking…',
    thoughtDetails: [],
    blocks: [],
  })
}
